import { IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { Stack, TextField } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch } from "react-redux";
import { updateGenieListNameThunk } from "../../dashboard/DashboardThunks";

export default function GeneListComponent(props) {
  const {
    item,
    closeMenu,
    changeActiveGenieList,
    deleteGenieList,
    driver,
    database,
  } = props;
  const dispatch = useDispatch();
  const [editGenieName, setEditGenieName] = useState(false);
  const [genieName, setGenieName] = useState(item?.genelist_name);
  return (
    <div key={item?.id} style={{ paddingLeft: 10 }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <div style={{ width: 300 }}>
          {editGenieName ? (
            <Stack direction="row" alignItems="center" spacing={1}>
              <TextField
                label="Genie Name"
                value={genieName}
                onChange={(event) => setGenieName(event.target.value)}
              />
              <IconButton
                size="small"
                style={{ width: 40, height: 40 }}
                onClick={() => {
                  dispatch(
                    updateGenieListNameThunk(
                      driver,
                      database,
                      item?.id,
                      genieName
                    )
                  );
                  setEditGenieName(false);
                }}
              >
                <CheckIcon />
              </IconButton>
              <IconButton
                size="small"
                style={{ width: 40, height: 40 }}
                onClick={() => {
                  setEditGenieName(false);
                  setGenieName(item?.genelist_name);
                }}
              >
                <ClearIcon />
              </IconButton>
            </Stack>
          ) : (
            <Typography
              style={{
                cursor: "pointer",
                color: item?.active_genelist ? "red" : "green",
              }}
              onClick={() => {
                changeActiveGenieList(item);
                closeMenu();
              }}
            >
              {`${item?.genelist_name}`}
            </Typography>
          )}
        </div>
        <div
          style={{
            width: 50,
            color: item?.active_genelist ? "red" : "green",
          }}
        >
          <Typography>{item?.gene_count}</Typography>
        </div>
        <IconButton
          onClick={() => {
            setEditGenieName(true);
          }}
        >
          <EditIcon
            style={{ color: item?.active_genelist ? "red" : "black" }}
          />
        </IconButton>
        <IconButton onClick={() => deleteGenieList(item)}>
          <DeleteIcon
            style={{ color: item?.active_genelist ? "red" : "black" }}
          />
        </IconButton>
      </Stack>
    </div>
  );
}
